import { validateTheLoginAdapter } from "../../../../../adapters/valideTheLogin/valideTheLogin.adapter";
// @ts-ignore
import { getUserPermissions } from "@viuti/recursos";

const validateTheLogin = async ({
  setIsButtonLoading,
  setCanUserContinue,
  setCurrentView,
  loginForm,
  setBusinessList,
  setToast,
  setIsBannerVisible,
  setLoungesList,
}) => {
  setIsButtonLoading(true);
  const response = await validateTheLoginAdapter(
    loginForm.email,
    loginForm.password
  );
  if (response.isSuccess) {
    const companyList = response.data.companyList;
    // Guard: si el backend no devolvió ninguna empresa/local accesibles
    // (empleado con relación inactiva o sin permisos), no podemos continuar.
    if (!Array.isArray(companyList) || companyList.length === 0) {
      setIsButtonLoading(false);
      setCanUserContinue(true);
      setToast({
        message:
          "Tu cuenta no tiene acceso a ningún local. Contacta al administrador para que active tu acceso.",
        status: 403,
      });
      return;
    }
    setIsBannerVisible(false);
    setBusinessList(companyList);
    setLoungesList(companyList[0].lounges || []);
    setToast({
      message: response.message,
      status: 200,
    });

    const isSingleCompanyAndLocal =
      companyList.length === 1 && (companyList[0].lounges?.length || 0) === 1;

    if (isSingleCompanyAndLocal) {
      // Saltar selección de empresa/local: hacer segundo token directamente
      const business = companyList[0];
      const lounge = business.lounges[0];
      localStorage.setItem(
        "selectedLocal",
        JSON.stringify({ id: lounge.loungeId, nombre: lounge.loungeName })
      );
      const secondResponse = await validateTheLoginAdapter(
        loginForm.email,
        loginForm.password,
        business.businessId,
        lounge.loungeId
      );
      setIsButtonLoading(false);
      if (secondResponse.isSuccess) {
        const perms = getUserPermissions();
        const dest = perms?.startView || "/cajas";
        window.location.href = dest;
      }
    } else {
      setIsButtonLoading(false);
      companyList.length === 1
        ? setCurrentView(2)
        : setCurrentView(1);
    }
  } else {
    setToast({
      message: response.message,
      status: 400,
    });
    setIsButtonLoading(false);
    setCanUserContinue(true);
  }
};

export default validateTheLogin;
